import type { ColorVariant } from "@storytell/types";

// getItemForText deterministically choose an item from an array based on the text.
function getItemForText<T>(text: string, items: T[]): T {
  // Create a simple hash of the string
  const hash = text.split("").reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc);
  }, 0);

  // Use the hash to select an item from our array
  const index = Math.abs(hash) % items.length;
  const item = items[index];

  if (!item) {
    throw new Error(`No item found for index: ${index}`);
  }

  return item;
}

// getColorVariantForText deterministically choose a color based on the text.
export function getColorVariantForText(text: string, variants: ColorVariant[]): ColorVariant {
  return getItemForText(text, variants);
}
